"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SweepstakesSocketEventType = void 0;
var SweepstakesSocketEventType;
(function (SweepstakesSocketEventType) {
    SweepstakesSocketEventType["BroadcastChat"] = "sweepstakes-broadcast-chat";
    SweepstakesSocketEventType["ReceiveChat"] = "sweepstakes-receive-chat";
    SweepstakesSocketEventType["EnterLobby"] = "sweepstakes-enter-lobby";
    SweepstakesSocketEventType["LeaveLobby"] = "sweepstakes-leave-lobby";
    SweepstakesSocketEventType["ReceiveCandidates"] = "sweepstakes-receive-candidates";
    SweepstakesSocketEventType["ReceiveStatus"] = "sweepstakes-receive-status";
    SweepstakesSocketEventType["ReceiveStart"] = "sweepstakes-receive-start";
    SweepstakesSocketEventType["ReceivePlayerCount"] = "sweepstakes-receive-player-count";
    SweepstakesSocketEventType["ReceiveReferralEntry"] = "sweepstakes-receive-referral-entry";
})(SweepstakesSocketEventType || (exports.SweepstakesSocketEventType = SweepstakesSocketEventType = {}));
